export const IncotermsInfo = {
    grupoC: {
        grupoTitle: 'group_c_indirect',
        grupoData: `selling_part_hires`,
        cfr: {
            title: 'cost_freight_used',
            data: `cost_freight_used_desc`
        },
        cif: {
            title: 'cost_insurance_freight',
            data: `cost_insurance_freight_desc`
        },
        cpt: {
            title: 'carriage_paid',
            data: `carriage_paid_desc`
        },
        cip: {
            title: 'carriage_insurance',
            data: `carriage_insurance_desc`
        }
    },
    grupoD: {
        grupoTitle: 'group_d_direct',
        grupoData: `group_d_direct_desc`,
        dpu: {
            title: 'delivered_place_unloaded',
            data: `delivered_place_unloaded_desc`
        },
        dap: {
            title: 'delivered_place_point',
            data: `delivered_place_point_desc`
        },
        ddp: {
            title: 'delivered_duty_paid',
            data: `delivered_duty_paid_desc`
        }
    },
    grupoE: {
        grupoTitle: 'group_e_selling',
        grupoData: `group_e_selling_desc`,
        exw: {
            title: 'exworks',
            data: `exworks_desc`
        }
    },
    grupoF: {
        grupoTitle: 'group_f_indirect',
        grupoData: `group_f_indirect_desc`,
        fca: {
            title: 'free_carrier',
            data: `free_carrier_desc`
        },
        fas: {
            title: 'free_alongside',
            data: `free_alongside_desc`
        },
        fob: {
            title: 'free_board',
            data: `free_board_desc`
        }
    }
}